import React, { useCallback } from 'react';
import { Editor } from '@tiptap/react';
import * as monaco from 'monaco-editor'; // <-- for editor types
import TextEditor from './TextEditor';
import CodeEditor from './CodeEditor';

type SnippetProps = {
  fileName: string;
  fileType: string;
  fileLanguage: string;
  isActive: boolean;
  id: string;
  modelPath?: string;
  initialText?: string;
  loadedText?: string;
  readOnly: boolean;
  onUpdate: (
    payload: { editor?: Editor; editorRef?: monaco.editor.IStandaloneCodeEditor },
    snippetId: string
  ) => void;
};

const Snippet: React.FC<SnippetProps> = ({ fileName, fileType, isActive, id, fileLanguage, loadedText, onUpdate, readOnly }) => {

  const onUpdateStable = useCallback(
    (payload: { editor?: Editor; editorRef?: monaco.editor.IStandaloneCodeEditor }) => {
      onUpdate(payload, id);
    },
    [onUpdate, id]
  );

  const commentFor = (lang: string) => ({
    javascript: '// type your code here',
    typescript: '// type your code here',
    python: '# type your code here',
    html: '<!-- type your code here -->',
    css: '/* type your code here */',
  }[lang.toLowerCase()] ?? '// type your code here');
  return (
    <div style={{ height: '100%' }}>
      {
        fileType === 'text' ? (
          <TextEditor readOnly={readOnly} onUpdate={(payload) => onUpdate(payload, id)} />
        ) : (
          <CodeEditor isActive={isActive} readOnly={readOnly} fileLanguage={fileLanguage} onUpdate={onUpdateStable} initialText={commentFor(fileLanguage)} modelPath={`file:///snippet-${id}.${fileLanguage}`} />
        )
      }
    </div>
  );
};

export default Snippet;
